import { render } from "./GeneralLoading.vue?vue&type=template&id=e3bbc8e6&scoped=true"
import script from "./GeneralLoading.vue?vue&type=script&lang=js"
export * from "./GeneralLoading.vue?vue&type=script&lang=js"

import "./GeneralLoading.vue?vue&type=style&index=0&id=e3bbc8e6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3bbc8e6"]])

export default __exports__